import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { GetAttendanceSummaryDailyPlaceListItem } from './attendance-api-types';

// 共通の型定義
type AttendanceTablePersonColumn = {
  id: string;
  avatarUrl?: string;
  name: string;
  email?: string;
  linkTo: string;
};
type AttendanceTableClockInColumn = GetAttendanceSummaryDailyPlaceListItem['clockIns'][number];
type AttendanceTableClockOutColumn = GetAttendanceSummaryDailyPlaceListItem['clockOuts'][number];
type AttendanceTableRestTimeColumn = {
  totalRestTimeMinutes: number;
  restTimes: GetAttendanceSummaryDailyPlaceListItem['restTimes'][number][];
  isEdited: boolean;
  editReason?: string;
};

// 共通のカラム定義
export const AttendanceTableColumns = {
  PERSON: 'person',
  DATE: 'date',
  CLOCK_INS: 'clockIns',
  CLOCK_OUTS: 'clockOuts',
  TOTAL_WORKING_TIME_MINUTES: 'totalWorkingTimeMinutes',
  REST_TIMES: 'restTimes',
  IS_VALID: 'isValid',
  ERRORS: 'errors'
} as const;
export type AttendanceTableColumns = EnumUnion<typeof AttendanceTableColumns>;

// 共通の行の型定義
export type AttendanceTableRow = {
  [AttendanceTableColumns.PERSON]?: AttendanceTablePersonColumn;
  [AttendanceTableColumns.DATE]: Date;
  [AttendanceTableColumns.CLOCK_INS]: AttendanceTableClockInColumn[];
  [AttendanceTableColumns.CLOCK_OUTS]: AttendanceTableClockOutColumn[];
  [AttendanceTableColumns.REST_TIMES]: AttendanceTableRestTimeColumn;
  [AttendanceTableColumns.TOTAL_WORKING_TIME_MINUTES]: number;
  [AttendanceTableColumns.IS_VALID]: boolean;
  [AttendanceTableColumns.ERRORS]: string[];
};